import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { MatIcon } from '@angular/material/icon';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ContentAnimDirective } from '../../product-layout/content-anim.directive';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { DefaultFlexDirective } from '../../../flex-layout/flex';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { CommonService } from '../../../services/common.service';
import { FormPopupComponent } from '../form-popup/form-popup.component';


@Component({
  selector: 'calsoft-button-row-header',
  imports: [DefaultLayoutDirective,ContentAnimDirective, DefaultFlexDirective, DefaultStyleDirective,MatButtonModule,MatButton, EditorTextComponent, MatIcon],
  templateUrl: './button-row-header.component.html',
  styleUrl: './button-row-header.component.scss'
})
export class ButtonRowHeaderComponent {

   @Input() item: any;
  @Input() data: any;
  @Input() value: any ;
  crmis = false;
  ngOnInit() {
    this.crmis = this.router.url.includes('enteprise-crm-solution');

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = (event as NavigationEnd).urlAfterRedirects || event.url;
        this.crmis = url.includes('enteprise-crm-solution');
      });
  }

  constructor(
    public dialog: MatDialog,
    private commonService:CommonService,
     public router: Router
  ){

  }




callToFunction(type: any,value: any){

 this.commonService.navigateButton(type,value)
  // this.commonService.goToLink('contact-us')

}
active: any;
scrollDown(value: any){
  this.active =value;
  this.ScrollIntoView(this.active);
}

ScrollIntoView(elem: string) {
  this.active = "#" + elem;
  const ele = document.querySelector(this.active) as HTMLElement;
  
  if (ele) {
    const offsetTop = ele.getBoundingClientRect().top + window.pageYOffset;
    const paddingTop = 96;
    window.scrollTo({
    top: offsetTop - paddingTop,
    behavior: 'smooth'
    });
  } else {
    console.error('Element not found:', this.active);
  }
  }


  link(url: any) {

   this.commonService.goToLink(url)
  
 }

 dynamicFormPopup(formGroupId:any) {
   if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(FormPopupComponent, {
         width: '790px',
         data: { formId: formGroupId}
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });

   }
   else {
      let dialogRef = this.dialog.open(FormPopupComponent, {
         minWidth: '100vw', height: '100vh',
         data: { formId: formGroupId}
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
   }

}

navigateToConnect1() {
  // Navigate to connect page
  this.router.navigate(['/contact-us']);
}

navigateToConnect() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}


}
